import React from 'react';
import { Link } from 'react-router';
import { I18n as I } from 'react-redux-i18n';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { ImageAntCellRenderer } from 'components/tables/datagrid-columns/PhotosCellRenderer';

import 'static/css/csshake-rotate.css';

import { Card } from 'antd';

import { formatCurrencyRounded } from 'vdlib';

import Portlet from '../layout/Portlet';
import Counter from './Counter';

const containerClassName = 'col-md-3 col-sm-6 col-12';

const { Meta } = Card;

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1800 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 1800, min: 1600 },
    items: 4,
  },
  smallDesktop: {
    breakpoint: { max: 1600, min: 1200 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1200, min: 600 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
  },
};

const MerchantDashboard = ({
  NewAuctionsCount,
  ParticipatingAmount,
  ParticipatingAuctionsCount,
  TotalActiveAuctionCount,
  TotalForAcceptAuctionAmount,
  TotalForAcceptAuctionCount,
  NewAuctions,
}) => (
  <div>
    <div className="row">
      <Link to="/auctions/new" className={containerClassName}>
        <Counter
          colorClassName="yellow-crusta"
          icon="star-o"
          title={I.t('NEW_FEMALE_PL')}
          value={NewAuctionsCount}
        />
      </Link>
      <Link to="/auctions" className={containerClassName}>
        <Counter
          colorClassName="blue"
          icon="car"
          title={I.t('CURRENT')}
          value={TotalActiveAuctionCount}
        />
      </Link>
      <Link to="/auctions/participate-to" className={containerClassName}>
        <Counter
          colorClassName="purple-intense"
          icon="thumbs-o-up"
          title={I.t('PARTICIPATE_TO')}
          value={ParticipatingAuctionsCount}
          amount={formatCurrencyRounded(ParticipatingAmount)}
        />
      </Link>
      <Link to="/auctions/for-acceptance" className={containerClassName}>
        <Counter
          colorClassName="green-jungle"
          icon="eur"
          title={I.t('FOR_ACCEPTANCE')}
          value={TotalForAcceptAuctionCount}
          amount={formatCurrencyRounded(TotalForAcceptAuctionAmount)}
        />
      </Link>
    </div>

    {NewAuctions ? (
      <Portlet title={I.t('AUCTIONS_NEW_C')}>
        <Carousel
          responsive={responsive}
          swipeable={false}
          draggable={false}
          showDots={true}
          infinite={false}
          autoPlay={true}
          autoPlaySpeed={5000}
          keyBoardControl={true}
          customTransition="all .5"
          transitionDuration={500}
          containerClass="carousel-container"
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {NewAuctions &&
            NewAuctions.map(auction => (
              <Link
                to={'/auctions/' + auction.ID}
                className={containerClassName}
              >
                <Card hoverable style={{ width: 300 }}>
                  <Meta
                    title={
                      <div
                        style={{
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            fontWeight: 600,
                          }}
                        >
                          {auction.VehicleBrand}
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            fontWeight: 600,
                          }}
                        >
                          {auction.VehicleModel}
                        </div>
                      </div>
                    }
                  />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {ImageAntCellRenderer(auction)}
                  </div>
                </Card>
              </Link>
            ))}
        </Carousel>
      </Portlet>
    ) : null}
  </div>
);

export default MerchantDashboard;
